// extracted by mini-css-extract-plugin
export default {"cardLabel":"CardLabel_cardLabel__pMKJ4","primary":"CardLabel_primary__TkkQY","secondary":"CardLabel_secondary__CPIik"};